<template lang="pug">
aiq-dropdown.full-width(placement="top-end",
                        :hide-timeout="5"
                        class="mt-1"
                        popper-class="quick-response-dropdown"
                        @visible-change="handleVisibleChange")
  template(v-slot:dropdown)
    aiq-dropdown-menu.context-menu.quick-response-menu
      template(v-if="readOnly")
        aiq-dropdown-item.context-menu-item(key="add-to-mine", command="add-to-mine")
          aiq-tooltip(effect="dark", placement="top", :content="$t(`${BASE_TRANSLATION_PATH}.add_to_mine`)", :show-after="500")
            .menu-item-icon(@click="$emit('add-to-mine', response)")
              i(class="el-icon-plus")
      template(v-else)
        aiq-dropdown-item.context-menu-item(key="is_pinned", command="is_pinned")
          aiq-tooltip(effect="dark", placement="top", :content="$t(`${BASE_TRANSLATION_PATH}.${response.is_pinned ? 'unpin': 'pin' }`)", :show-after="500")
            .menu-item-icon(@click="togglePinRespone")
              fa-icon(:icon="[response.is_pinned ? 'far' : 'fas', 'thumbtack']")
        aiq-dropdown-item.context-menu-item(key="edit", command="edit")
          aiq-tooltip(effect="dark", placement="top", :content="$t(`${BASE_TRANSLATION_PATH}.edit`)", :show-after="500")
            .menu-item-icon(@click="$emit('editMode', response.id);")
              i(class="el-icon-edit")
        aiq-dropdown-item.context-menu-item(key="delete", command="delete")
          aiq-tooltip(effect="dark", placement="top", :content="$t(`${BASE_TRANSLATION_PATH}.delete`)", :show-after="500")
            .menu-item-icon(@click="$emit('remove', response)")
              i(class="el-icon-delete")
  .quick-response_list-item(@click="selectResponse", :class="{'is-pinned': response.is_pinned}")
    aiq-tooltip(effect="dark"
              placement="left"
              :content="normalizedContent"
              raw-content
              popper-class="rich-text-tooltip"
              :show-after="500")
      .quick-response_list-item_content
        .quick-response_list-item_content-text.side-panel-quick-response-text(v-html="normalizedContent")
</template>

<script>
import { normalizeEmptyParagraphs } from '@/libs';

export default {
  inject: ['focusOnInputbox'],
  data() {
    return {
      BASE_TRANSLATION_PATH: 'conversation_tab.side_panel.quick_reponses_accordion',
    };
  },
  computed: {
    normalizedContent() {
      return normalizeEmptyParagraphs(this.response.content);
    },
  },
  props: {
    response: {
      type: Object,
      required: true,
    },
    readOnly: Boolean,
  },
  emits: ['editMode', 'remove', 'select'],
  methods: {
    togglePinRespone() {
      this.$emit(this.response.is_pinned ? 'unpin' : 'pin', this.response.id);
    },

    selectResponse() {
      this.$emit('select', this.response);
    },

    handleVisibleChange(isVisible) {
      if (!isVisible) {
        this.focusOnInputbox();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../../../../../styles/aiq-variables.scss";
@import "./../../../../../../styles/aiq-mixins.scss";

.full-width {
  width: 100%;
}

.el-icon-edit {
  margin-left: 0;
}

.quick-response_list-item {
  position: relative;
  margin-top: 8px;
  color: #F9FAFC;
  font-size: 11px;
  line-height: 13px;
  font-weight: 300;
  border-radius: 4px;
  background-color: #414246;

  &.is-pinned {
    background-color: #5A88DE;
  }

  &:hover {
    box-shadow: 0 0 2px 0 rgba(50,64,87,0.90);
    background-color: #80ACFF;

    &:not(.is-pinned) {
     background-color: #66676a;
    }

    .quick-response_list-item_actions  button.el-button {
      color: #fff;
    }
  }

  .quick-response_list-item_content {
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    .quick-response_list-item_actions {
      margin-left: 4px;
      .el-button {
        padding: 0;
        color: #BFCBD9;
        font-size: 10px;
        border: 0;
        background-color: transparent;
      }
    }
  }
}
ul.quick-response-menu.el-zoom-in-top-leave-active {
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}

.side-panel-quick-response-text {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  :deep(p) {
    color: #fff !important;
  }
  :deep(a) {
    text-decoration: underline !important;
  }
  :deep(h1) {
    line-height: 1.5rem;
    color: #fff !important;
  }
  :deep(h2) {
    line-height: 1.4rem;
    color: #fff !important;
  }
  :deep(h3) {
    line-height: 1.3rem;
    color: #fff !important;
  }
  :deep(h4) {
    line-height: 1.2rem;
    color: #fff !important;
  }
  :deep(h5) {
    line-height: 1.1rem;
    color: #fff !important;
  }
  :deep(h6) {
    line-height: 1.0em;
    color: #fff !important;
  }
  @include list-reset;
}

.quick-response_list-item {
  &.is-pinned {
    .quick-response_list-item_content-text {
      :deep(a) {
        color: var(--el-color-primary-light-5) !important;
      }
    }
  }
  .quick-response_list-item_content-text {
    :deep(a) {
      color: var(--el-color-primary-light-3) !important;
      pointer-events: none;
    }
  }
}
</style>
